import { DEFAULT_WORKING_HOURS, type Permission } from '@pa/core';

/** The limit line shown under calendar_write at auto (the default limit when none is written). */
export function limitLine(p: Permission, t: (k: string) => string): string {
  const limit = p.limit ?? {
    working_hours: DEFAULT_WORKING_HOURS,
    no_new_external_attendees: true,
  };
  const parts: string[] = [];
  if (limit.working_hours) parts.push(t('permissions.limits.workingHours'));
  if (limit.no_new_external_attendees) parts.push(t('permissions.limits.noNewExternal'));
  return parts.join(' · ');
}
